/**
 * Nguồn dữ liệu dự toán tùy chỉnh báo cáo
 * pqkhanh 09.08.2024
 */
export default {
  SUM: 5,
  COUNT: 10,
  AVG: 15,
};
